import {Badge} from "@/components/ui/badge";
import {cn} from "@/lib/utils";

import {
  getPermitStatusBadgePropsForDisplay,
  getSuspendedFuturePermitQualifierLabel,
  isSuspendedFuturePermit,
} from "../lib/permit-status";
import type {PermanentParkingPermit} from "../types";

type PermitCoverageStatusClusterProps = {
  permit: PermanentParkingPermit;
  timeZone: string;
  className?: string;
  badgeClassName?: string;
  align?: "start" | "end";
};

export function PermitCoverageStatusCluster({
  permit,
  timeZone,
  className,
  badgeClassName,
  align = "end",
}: PermitCoverageStatusClusterProps) {
  const badge = getPermitStatusBadgePropsForDisplay(permit.status, permit);
  const suspendedFuture = isSuspendedFuturePermit(permit, timeZone);
  const futureQualifierLabel = suspendedFuture
    ? getSuspendedFuturePermitQualifierLabel(permit, timeZone)
    : null;

  return (
    <div
      className={cn(
        "flex max-w-full shrink-0 flex-col gap-1",
        align === "end" ? "items-end" : "items-start",
        className,
      )}
    >
      <Badge variant={badge.variant} className={badgeClassName}>
        {badge.label}
      </Badge>
      {futureQualifierLabel ? (
        <Badge variant="outline" className="text-xs font-semibold whitespace-nowrap">
          {futureQualifierLabel}
        </Badge>
      ) : null}
    </div>
  );
}
